let createClient = null;
try {
  ({ createClient } = require("@supabase/supabase-js"));
} catch {
  // Pacchetto non installato in node_modules — app resta utilizzabile in dev locale
}

const url = process.env.REACT_APP_SUPABASE_URL || "";
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

/** True se URL, anon key e SDK Supabase sono disponibili. */
export const isSupabaseConfigured = Boolean(url && anonKey && createClient);

/**
 * Client Supabase singleton. Se non configurato, le chiamate auth falliranno:
 * usare `isSupabaseConfigured` prima di signIn.
 */
export const supabase = isSupabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
